import { useSmsRegistrationDeadline } from 'hooks/useSmsRegistrationDeadline';
import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';
import { getValidOrgId } from 'utils/storageUtils';

export function useAddingCandidatesDisabled(): boolean {
  const flagDisabled = useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.adding_candidates_disabled)
  );
  const { deadline } = useSmsRegistrationDeadline(getValidOrgId());
  return flagDisabled || deadline?.state === 'locked';
}
